import React, { useState } from 'react';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import '../Styles/ContactForm.css';

const Contact = ({ openLoginModal, openRegisterModal }) => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = (event) => {
        event.preventDefault();
        console.log('Submitting:', { name, email, message });
    };

    return (
        <>
            <Navbar openLoginModal={openLoginModal} openRegisterModal={openRegisterModal} />

            <div className="container">
                <form onSubmit={handleSubmit} className="form">
                    <h2>Contact gegevens</h2>
                    <div className="inputGroup">
                        <label htmlFor="name" className="label">Naam:</label>
                        <input
                            type="text"
                            id="name"
                            className="input"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />
                    </div>
                    <div className="inputGroup">
                        <label htmlFor="email" className="label">Email:</label>
                        <input
                            type="email"
                            id="email"
                            className="input"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <div className="inputGroup">
                        <label htmlFor="message" className="label">Bericht:</label>
                        <textarea
                            id="message"
                            className="textarea"
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            required
                        />
                    </div>
                    <button type="submit" className="button">Verzenden</button>
                </form>
            </div>

            <Footer />
        </>
    );
};

export default Contact;
